import {
  toValue,
  useNuxtApp,
  useRequestEvent
} from "#imports";
export function useSiteConfig(options) {
  let stack;
  if (process.server)
    stack = useRequestEvent().context.siteConfig.get();
  else
    stack = useNuxtApp().$nuxtSiteConfig.get();
  if (!options?.withContext)
    delete stack._context;
  Object.entries(stack).forEach(([k, v]) => {
    stack[k] = toValue(v);
  });
  return stack;
}
